import { useMemo } from 'react';
import { FilterToolbarItemId } from 'src/components/Filters';
import { useFilterQueryContext } from 'src/contexts/FilterQueryContext';
import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { PosTextField } from 'src/core/POS/PosTextField';
import { ContentId } from 'src/utils/constants/contentId';
import { YES_NO_ENUM_FILTER_TO_CID } from 'src/utils/constants/contentIdMaps';
import { FromYesNoEnum, ToYesNoEnum } from 'src/utils/eventQueryUtils';
import { MarketplacePaymentLineQuery } from 'src/WebApiController';

export const useMarketplacePaymentLinesFilters = () => {
  const { tempQuery, setTempQuery } =
    useFilterQueryContext<MarketplacePaymentLineQuery>();
  return useMemo(() => {
    return {
      filters: [
        {
          titleContentId: ContentId.Payment,
          type: 'row',
          items: [
            {
              labelContentId: ContentId.HasUnlinkedChargesCredits,
              filterId: 'hasUnlinkedChargesCredits' as FilterToolbarItemId,
              filterQueryKeys: [
                'hasUnlinkedChargesCredits',
              ] as FilterToolbarItemId[],
              filterItem: (
                <PosEnumSelect
                  style={{ width: '100%' }}
                  value={ToYesNoEnum(tempQuery.hasUnlinkedChargesCredits)}
                  placeholderText={ContentId.All}
                  enableEmptySelection
                  onChange={(yesNoEnumValue) => {
                    if (
                      yesNoEnumValue !==
                      ToYesNoEnum(tempQuery.hasUnlinkedChargesCredits)
                    ) {
                      setTempQuery({
                        ...tempQuery,
                        hasUnlinkedChargesCredits:
                          FromYesNoEnum(yesNoEnumValue),
                      });
                    }
                  }}
                  valueOptionsContent={YES_NO_ENUM_FILTER_TO_CID}
                />
              ),
            },
            {
              labelContentId: ContentId.ExternalSaleIdContains,
              filterId: 'externalSaleIdContains' as FilterToolbarItemId,
              filterQueryKeys: [
                'externalSaleIdContains',
              ] as FilterToolbarItemId[],
              filterItem: (
                <PosTextField
                  style={{ width: '100%' }}
                  value={tempQuery.externalSaleIdContains ?? ''}
                  type="text"
                  onChange={(e) => {
                    const newValue = e.target.value?.length
                      ? e.target.value.trim()
                      : null;
                    if (tempQuery.externalSaleIdContains !== newValue) {
                      setTempQuery({
                        ...tempQuery,
                        externalSaleIdContains: newValue,
                      });
                    }
                  }}
                  maxLength={200}
                />
              ),
            },
          ],
        },
      ],
    };
  }, [setTempQuery, tempQuery]);
};
